import React from 'react';
import { makeStyles } from '@mui/styles';
import { Styles } from '../../../config/design/styles';
import '../../../files/css/editor-view.css';

const useStyles = makeStyles(Styles);

const EditorPreviewHTML = ({ html }) => {

    return (
        <div className="editor-text">
            <div dangerouslySetInnerHTML={{ __html: html }} />
        </div>

    );
};

export default EditorPreviewHTML;
